<template>
  <v-base-card>
    <template v-slot:heading>
      解約フォーム
    </template>
    <template v-slot:content>
      <!-- 解約のチェック項目 -->
      <div class="confirm__area">
        <v-cancel-form class="ml-3" @click-confirm="onClickCancelConfirm"/>
      </div>
      <div>
        <v-btn class="ml-3 mt-4" small color="gray" @click="$router.go(-1)">戻る</v-btn>
      </div>
    </template>
  </v-base-card>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex"

import VBaseCard from '@/components/molecules/BaseCard'
import VCancelForm from '@/components/organizms/CancelForm'

export default {
  components: {
    VBaseCard,
    VCancelForm
  },
  data() {
    return {
      selected: [],
      branch: null,
    }
  },
  async mounted(){
    const res = await this.$axios.get(`/api/v1/teacher/branch/${this.$store.state.user.id}`)
    this.branch = res.data

    this.$gtag.pageview({
      page_path: '/cancel',
      page_title: "解約フォーム"
    })
  },
  beforeDestroy() {
    this.initializeForm()
  },
  computed: {
    ...mapState('enrollment', [
      'cancelForm'
    ]),
    ...mapGetters('enrollment', [
    ]),
  },
  methods: {
    ...mapMutations('enrollment', [
      'initializeForm',
    ]),
    async onClickCancelConfirm() {
      const params = {
        cancellationRequest: {
          customerId: this.branch.customerId,
          cancellationApplicant: this.cancelForm.name,
          cancellationRequestReasonsAttributes: this.cancelForm.selectedReason.map(sr => {
            return {
              cancellationReasonId: sr,
              otherDetail: sr === 7 ? this.cancelForm.message : ''
            }
          }),
        },
        branchIds: [this.branch.id]
      }
      await this.$axios.post('/api/v1/enrollment/cancellation_requests', params)
      this.$toasted.global.success({ message: '解約の申込が完了しました' })
      this.$router.push('/teacher/home')
    }
  }
}
</script>

<style lang="stylus" scoped>

.confirm__btn
  background-color #D65B5B !important
  border-color #D05353 !important
  color white

</style>
